import { isValidValue } from "utils";

/**
 * Set image/file data to form control
 */
export const setImageData = (el, data, form, keyName = "image") => {
  const temp = {
    value: el.file,
    image: URL.createObjectURL(el.file),
    thumb: URL.createObjectURL(el.file),
    original: URL.createObjectURL(el.file),
    upload: isValidValue(data.upload) ? data.upload : true,
    imgSrc: data.imgSrc,
    imgSrcExt: data.imgSrcExt,
    crop: el.crop,
    label: "",
  };
  if (isValidValue(form)) {
    // Set the image group and mark it touched (not a user "edit")
    form.setValue(keyName, temp, { shouldTouch: true, shouldValidate: true });
  }
};

/**
 * getImageExtensionFromBase64
 * ---------------------------
 * Extracts the image file extension from a base64-encoded image string.
 *
 * @param {string} base64Data - The base64 string (e.g., "data:image/png;base64,...")
 * @returns {string} The image extension (e.g., "png", "jpeg", "gif").
 */
export const getImageExtensionFromBase64 = (base64Data) => {
  if (!base64Data || typeof base64Data !== "string") {
    throw new Error("Invalid base64Data: must be a non-empty string");
  }

  return base64Data.substring(
    "data:image/".length,
    base64Data.indexOf(";base64")
  );
}

